// extracted by mini-css-extract-plugin
export default {"UploadCancel":"UploadCancel___ZWcJ6"};